import React from 'react';
import ReactTooltip from "react-tooltip";
import classNames from "classnames";
import IconInfo from "./info.svg";
import styles from "./styles.module.scss";

const MultipleTooltip = ({
                           label,
                           id,
                           place,
                           effect,
                           customIconClassName,
                           customTooltipClassName,
                           icon = IconInfo
                         }) => {

  return (
    <div className={styles.container}>
      <div data-for={id} data-tip={label}>
        <img
          src={icon}
          alt="tooltipIcon"
          className={classNames(styles.icon, customIconClassName)}
        />
      </div>
      <ReactTooltip
        id={id}
        place={place}
        effect={effect}
        className={classNames(styles.tooltip, customTooltipClassName)}
        arrow={false}
        noArrow
      />
    </div>
  )
};

export default MultipleTooltip;
